import React, { useState, useEffect, useMemo } from "react";
import ExcelJS from 'exceljs';
import sort from "./../images/sort.png";
import "./../App.css";
import Select, { components } from "react-select";
import { customStyles } from "./../helpers/StyleUtils";
import { bookingService, companyService, uploadService, locationService } from "../api/apiService";

function ExcelUploadButton() {
  const [file, setFile] = useState(null);
  const [potentialOrders, setPotentialOrders] = useState([]);
  const [selectedOrders, setSelectedOrders] = useState({});
  const [selectAll, setSelectAll] = useState(false);
  const [isloading, setIsLoading] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [showUploadHistory, setShowUploadHistory] = useState(false);
  const [uploadHistoryPage, setUploadHistoryPage] = useState(1);
  const [uploadHistoryLimit] = useState(5);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });
  const [locations, setLocations] = useState([]);

  const [filters, setFilters] = useState({
    Studio: "",
    SetDesc: "",
    // Initialize other filters as needed
  });

  const DropdownIndicator = (props) => {
    return (
      components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
          <div style={{ width: "16px", margin: "0" }}>
            <svg
              version="1.1"
              id="Isolationsmodus"
              x="0px"
              y="0px"
              viewBox="0 0 322.9 257.78"
              shapeRendering="geometricPrecision"
            >
              <path
                xmlns="http://www.w3.org/2000/svg"
                d="M208.27,7.37c-4.69-4.79-11.12-7.4-17.72-7.81c-0.4-0.03-0.8-0.05-1.22-0.05l0,0h-35.34h-70.2H31.14h-4.27  C17.33-0.46,7.87,4.51,3.34,13.12C-1.19,21.65-1.3,32.3,4.19,40.47c0.85,1.3,1.74,2.56,2.6,3.82C17.3,59.73,27.77,75.2,38.27,90.64  c12.47,18.33,24.91,36.7,37.39,55.03c3.08,4.53,6.13,9.02,9.21,13.54c3.97,5.86,9.06,10.5,16.08,12.36  c6.87,1.86,14.85,0.93,20.9-2.93c3.79-2.45,6.24-5.12,8.8-8.79c8.06-11.54,15.82-23.3,23.76-34.96  c13.14-19.33,26.25-38.67,39.39-57.96c4.68-6.87,9.32-13.73,14-20.63c4.31-6.31,8.39-12.13,8.2-20.41  C215.85,18.95,213.1,12.34,208.27,7.37z"
              />
            </svg>
          </div>
        </components.DropdownIndicator>
      )
    );
  };
  // Handle checkbox change remains the same

  // Sorting function
  const requestSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
    sortArray(key, direction);
  };

  // Function to sort the array
  const sortArray = (key, direction = "ascending") => {
    if (!potentialOrders || potentialOrders.length === 0) return;
    
    setPotentialOrders(
      [...potentialOrders].sort((a, b) => {
        if (a[key] < b[key]) {
          return direction === "ascending" ? -1 : 1;
        }
        if (a[key] > b[key]) {
          return direction === "ascending" ? 1 : -1;
        }
        return 0;
      })
    );
  };

  const handleCheckboxChange = (index) => {
    setSelectedOrders((prevSelected) => ({
      ...prevSelected,
      [index]: !prevSelected[index],
    }));
  };

  function reformatDate(dateStr) {
    // Check if the date is in the format 'd.m.yyyy' or 'dd.mm.yyyy'
    const regex = /^\d{1,2}\.\d{1,2}\.\d{4}$/;

    if (regex.test(dateStr)) {
      // Split the date, pad each part with leading zero if necessary, and join with slashes
      return dateStr
        .split(".")
        .map((part) => part.padStart(2, "0"))
        .join("/");
    } else {
      // If the date is not in the expected format, return it as is
      return dateStr;
    }
  }

  function normalizeTime(timeStr) {
    // console.log('normalizeTime raw input:', timeStr, typeof timeStr);
    
    if (!timeStr) return '--:--';
    
    // If it's a Date object, extract time using UTC
    if (timeStr instanceof Date) {
      return `${timeStr.getUTCHours().toString().padStart(2, '0')}:${timeStr.getUTCMinutes().toString().padStart(2, '0')}`;
    }
    
    // If it's a date string, convert to Date and extract time using UTC
    if (typeof timeStr === 'string' && timeStr.includes('GMT')) {
      const date = new Date(timeStr);
      return `${date.getUTCHours().toString().padStart(2, '0')}:${date.getUTCMinutes().toString().padStart(2, '0')}`;
    }
    
    // If it's already in HH:MM format, return as is
    if (typeof timeStr === 'string' && timeStr.includes(':')) {
      return timeStr;
    }
    
    return timeStr || '--:--';
  }

  useEffect(() => {
    // console.log("Loading state is now:", isloading);
  }, [isloading]);
  const toggleSelectAll = () => {
    let newSelected = {};
    if (!selectAll && potentialOrders) {
      potentialOrders.forEach((_, index) => {
        newSelected[index] = true;
      });
    }
    setSelectedOrders(newSelected);
    setSelectAll(!selectAll);
  };

  const handleChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      setFile(file);
      await scanExcel(file);
    }
  };

  // Helper function to handle authentication errors
  const handleAuthError = (error) => {
    if (error.response && error.response.status === 401) {
      // console.log('Authentication error detected (401 Unauthorized), clearing storage and redirecting to login');
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = '/login';
      return true; // Indicates auth error was handled
    }
    return false; // Not an auth error
  };

  const scanExcel = async (selectedFile) => {
    // console.log("File selected:", selectedFile);
    setIsLoading(true);

    try {
      // Upload the Excel file using the upload service
      const description = `Excel upload for data extraction - ${new Date().toLocaleString()}`;
      const uploadResponse = await uploadService.uploadExcel(selectedFile, description);
      
      // console.log("Upload response:", uploadResponse.data);
      
      if (!uploadResponse.data || !uploadResponse.data.success) {
        throw new Error('File upload failed: ' + (uploadResponse.data?.message || 'Unknown error'));
      }

      // Store upload ID for future reference
      const uploadId = uploadResponse.data.uploadId;
      // console.log(`File uploaded successfully with ID: ${uploadId}`);

      // Try to get preview data from the API if available
      try {
        // console.log("Attempting to get preview data from API");
        const previewResponse = await uploadService.previewExcelFile(uploadId);
        
        if (previewResponse.data && previewResponse.data.success && previewResponse.data.previewData) {
          // console.log("Preview data received from API:", previewResponse.data);
          
          // Check if the API has already processed the data into the expected format
          if (previewResponse.data.processedOrders) {
            // console.log("API has already processed the orders:", previewResponse.data.processedOrders);
            setPotentialOrders(previewResponse.data.processedOrders);
            setIsLoading(false);
            return; // Exit early as we already have the data
          }
        }
      } catch (previewError) {
        // console.log("Preview data not available from API, will process locally:", previewError);
        // Continue with local processing
      }
      
      // Fall back to local processing if API doesn't provide the processed data
      // console.log("Processing Excel file locally");
      
      // Convert File object to ArrayBuffer for local processing
      const arrayBuffer = await selectedFile.arrayBuffer();
      
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(arrayBuffer);
      
      // Log available worksheets for debugging
      // console.log("Available worksheets:", workbook.worksheets.map(sheet => ({ 
        // id: sheet.id, 
        // name: sheet.name,
        // rowCount: sheet.rowCount
      // })));
      
      // Always use worksheet #2 as specified
      const firstWorksheet = workbook.getWorksheet(2);
      
      if (!firstWorksheet) {
        throw new Error("Worksheet #2 not found. Please check the Excel file structure.");
      }
      
      // console.log(`Processing worksheet #2: ${firstWorksheet.name} with ${firstWorksheet.rowCount} rows`);
      
      const columnMapping = {
        A: "Studio",
        B: "Set",
        C: "Datum",
        D: "Kundenshootings",
        E: "Start",
        F: "Ende",
        G: "KPI Plan",
        H: "Foto",
        I: "Digi-OP",
        J: "Styling Assist",
        K: "Video",
        L: "Styling",
        M: "Hair & Make-Up",
        N: "Art Direktion",
        O: "PRODUCER",
        P: "Sonstige Info",
        Q: "Location",
        R: "Model",
        S: "Model",
        T: "Id",
      };

      const relevantColumns = ["H", "I", "J", "K", "L", "M", "N", "O"];
      let extractedOrders = [];
      let rowCount = 0;
      let matchCount = 0;

      // Log some sample data for debugging
      const sampleRows = [];
      const sampleSize = 10; // Number of rows to sample
      
      // Process each row
      firstWorksheet.eachRow((row, rowNumber) => {
        rowCount++;
        const rowData = {};
        
        // Convert row values to an object with column letters as keys
        row.eachCell((cell, colNumber) => {
          const colLetter = String.fromCharCode(64 + colNumber);
          
          // Handle different cell types
          let cellValue;
          if (cell.type === ExcelJS.ValueType.Date) {
            cellValue = cell.value; // ExcelJS automatically converts dates
          } else if (cell.type === ExcelJS.ValueType.Number) {
            cellValue = cell.value;
          } else {
            cellValue = cell.text || cell.value;
          }
          
          rowData[colLetter] = cellValue;
        });
        
        // Add to sample data for debugging
        if (rowNumber <= sampleSize) {
          sampleRows.push({...rowData, rowNumber});
        }
        
        // Debug log for KPI column specifically
        if (rowNumber <= 5) {
          // console.log(`Row ${rowNumber} - Column G (KPI):`, rowData["G"], `Type:`, typeof rowData["G"]);
        }

        // Add more flexible matching - look for "anfrage" or "request" in any column
        let matchFound = false;
        relevantColumns.forEach(col => {
          if (
            rowData[col] &&
            (String(rowData[col]).toLowerCase().includes("anfrage".toLowerCase()) ||
             String(rowData[col]).toLowerCase().includes("request".toLowerCase()))
          ) {
            matchCount++;
            matchFound = true;
            
            let setModel;
            if (rowData["B"] && String(rowData["B"]).toLowerCase() === "model".toLowerCase()) {
              setModel = { value: "onmodel", label: "On Model" };
            } else if (rowData["B"]) {
              setModel = { value: "Produkt", label: "On Produkt" };
            } else {
              setModel = { value: "", label: "" };
            }

            // Convert Excel date to JavaScript date
            const datumValue = rowData["C"];
            let datumDate;

            try {
              if (datumValue instanceof Date) {
                datumDate = datumValue;
              } else if (typeof datumValue === 'string' && datumValue.includes('GMT')) {
                datumDate = new Date(datumValue);
              } else if (typeof datumValue === 'number') {
                datumDate = excelSerialDateToDate(datumValue);
              } else if (typeof datumValue === 'string') {
                const numberMatch = datumValue.match(/\d+/);
                if (numberMatch) {
                  datumDate = excelSerialDateToDate(Number(numberMatch[0]));
                } else {
                  datumDate = datumValue;
                }
              } else {
                datumDate = datumValue || new Date(); // Default to current date if missing
              }

              // Ensure datumDate has a toLocaleDateString method
              if (!(datumDate instanceof Date) || isNaN(datumDate.getTime())) {
                // console.warn(`Invalid date in row ${rowNumber}:`, datumDate);
                datumDate = new Date(); // Default to current date
              }
            } catch (dateError) {
              console.error(`Error processing date in row ${rowNumber}:`, dateError);
              datumDate = new Date(); // Default to current date
            }

            const orderData = {
              Studio: rowData["A"] || "",
              SetDesc: rowData["B"] || "",
              Set: setModel,
              Id: rowData["T"] || `ROW-${rowNumber}`, // Fallback ID if missing
              Datum: datumDate.toLocaleDateString(),
              Start: typeof rowData["E"] === 'string' && rowData["E"].includes('IFERROR') 
                ? excelFractionToTime(rowData["E"]) 
                : typeof rowData["E"] === 'number' 
                  ? excelFractionToTime(rowData["E"]) 
                  : rowData["E"],
              Ende: typeof rowData["F"] === 'string' && rowData["F"].includes('IFERROR') 
                ? excelFractionToTime(rowData["F"]) 
                : typeof rowData["F"] === 'number' 
                  ? excelFractionToTime(rowData["F"]) 
                  : rowData["F"],
              Kundenshootings: rowData["D"] || "",
              DatumEnd: datumDate.toLocaleDateString(),
              KPIPlan: (() => {
                const kpiValue = rowData["G"];
                // console.log(`KPI value from column G:`, kpiValue, `Type:`, typeof kpiValue);
                
                if (kpiValue === null || kpiValue === undefined || kpiValue === '') {
                  return 0;
                }
                
                // If it's already a number, round it
                if (typeof kpiValue === 'number') {
                  return Math.round(kpiValue);
                }
                
                // If it's a string, try to convert to number
                if (typeof kpiValue === 'string') {
                  const numericValue = parseFloat(kpiValue);
                  if (!isNaN(numericValue)) {
                    return Math.round(numericValue);
                  }
                  // If it's not a valid number, return 0
                  return 0;
                }
                
                // For any other type, try to convert to number
                const numericValue = parseFloat(kpiValue);
                return !isNaN(numericValue) ? Math.round(numericValue) : 0;
              })(),
              position: columnMapping[col],
              SonstigeInfo: rowData["P"] || "",
              Location: rowData["Q"] || "",
              Model: rowData["R"] || "",
              rowNumber: rowNumber, // Add row number for reference
            };

            // console.log(`Found potential order in row ${rowNumber}, col ${col}:`, orderData);
            extractedOrders.push(orderData);
          }
        });
      });

      // console.log(`Processed ${rowCount} rows, found ${matchCount} matches in relevant columns`);
      // console.log("Sample rows from worksheet:", sampleRows);
      
      // Log matches by column for debugging
      const matchesByColumn = {};
      if (relevantColumns && columnMapping) {
        relevantColumns.forEach(col => {
          if (extractedOrders && columnMapping[col]) {
            matchesByColumn[col] = extractedOrders.filter(o => o.position === columnMapping[col]).length;
          } else {
            matchesByColumn[col] = 0;
          }
        });
      }
      // console.log("Matches by column:", matchesByColumn);
      
      if (!extractedOrders || extractedOrders.length === 0) {
        console.error("No orders found with standard matching criteria.");
        // console.log("Sample data from first 10 rows:", sampleRows);
      }

      // Group orders by Id and position
      let mergedOrders = {};
      extractedOrders.forEach((order) => {
        const key = order.Id + "/" + order.position;
        if (!mergedOrders[key]) {
          mergedOrders[key] = { ...order, count: 1 };
        } else {
          mergedOrders[key].DatumEnd = order.Datum;
          mergedOrders[key].count += 1;
        }
      });

      const finalOrders = Object.values(mergedOrders).map((order) => ({
        ...order,
        NumDays: order.count,
      }));

      // console.log("Final orders:", finalOrders); // Debug log
      setPotentialOrders(finalOrders);
      setIsLoading(false);

    } catch (error) {
      console.error("Error processing Excel file:", error);
      setIsLoading(false);
      
      // Check for authentication errors first
      if (handleAuthError(error)) {
        return; // Don't show alert if redirecting to login
      }
      
      // Extract the most useful error message
      let errorMessage = error.message;
      
      // If it's an API error with a response
      if (error.response && error.response.data) {
        errorMessage = error.response.data.message || error.response.data || errorMessage;
      }
      
      alert(`Error processing Excel file: ${errorMessage}`);
    }

    // Firebase storage upload code...
  };

  // Helper function for Excel date conversion
  const excelSerialDateToDate = (serial) => {
    const utc_days  = Math.floor(serial - 25569);
    const utc_value = utc_days * 86400;  
    const date_info = new Date(utc_value * 1000);
    return new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate());
  };

  // Helper function for Excel time conversion
  const excelFractionToTime = (fraction) => {
    // console.log('Time conversion input:', fraction, 'Type:', typeof fraction);
    
    if (!fraction && fraction !== 0) return '';
    
    // If it's already in time format (string like "HH:MM"), return it
    if (typeof fraction === 'string' && fraction.includes(':')) {
      return fraction;
    }
    
    // Handle Excel formula strings
    if (typeof fraction === 'string' && fraction.includes('IFERROR')) {
      // Extract the decimal number after the last semicolon
      const matches = fraction.match(/;([0-9,.]+)/);
      if (matches && matches[1]) {
        // Convert comma to dot for decimal parsing
        fraction = parseFloat(matches[1].replace(',', '.'));
      }
    }
    
    // Convert to number if it's a string number
    if (typeof fraction === 'string') {
      fraction = parseFloat(fraction);
    }
    
    // Check if we have a valid number after conversion
    if (isNaN(fraction)) {
      // console.log('Invalid time value:', fraction);
      return '';
    }
    
    // Convert from Excel fraction directly to HH:MM string
    const totalMinutes = Math.round(fraction * 24 * 60);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  };

  function parseDate(dateString) {
    const parts = dateString.split("/");
    // Note: months are 0-based in JavaScript Date, so subtract 1
    return new Date(parts[2], parts[1] - 1, parts[0]);
  }

  function parseISODate(dateString) {
    return new Date(dateString);
  }

  function toISOFormat(dateStr) {
    // Assuming dateStr is in 'dd/mm/yyyy' format
    const parts = dateStr.split("/");
    if (parts.length === 3) {
      return `${parts[2]}-${parts[1]}-${parts[0]}`; // Convert to 'yyyy-mm-dd'
    }
    return dateStr; // Return the original string if it doesn't match the expected format
  }

  const createSelectedOrders = async () => {
    setIsLoading(true);
    try {
      for (let index in selectedOrders) {
        if (selectedOrders[index]) {
          const order = potentialOrders[index];

          // Extract or determine the values for the new fields
          const isoStartDate = toISOFormat(reformatDate(order.Datum));
          const startDate = parseISODate(isoStartDate);

          const isoEndDate = toISOFormat(reformatDate(order.DatumEnd));
          const endDate = parseISODate(isoEndDate);
          
          // Find location ID based on location text
          const locationMatch = findLocationId(order.Location);
          
          // Create new booking data object in the format expected by the API
          const newOrderData = {
            // Required fields
            title: order.SetDesc || "New Order", // Required field
            talent_id: "pending", // Required field - will be assigned later in the workflow
            status: "new order", // Required field
            start_date: startDate.toISOString().split('T')[0], // Format as YYYY-MM-DD
            
            // Optional fields
            end_date: startDate.toISOString().split('T')[0],
            start_time: normalizeTime(order.Start),
            end_time: normalizeTime(order.Ende),
            kpi: order.KPIPlan,
            set: order.Set.label,
            set_desc: order.SetDesc,
            position: {
              value: order.position,
              label: order.position
            },
            client: {
              value: order.Kundenshootings,
              label: order.Kundenshootings
            },
            range: "",
            group: "",
            option: "option",
            // Use location object with ID if found, otherwise just the text
            location: locationMatch ? {
              id: locationMatch.id,
              name: locationMatch.name,
              short: locationMatch.short,
              city: locationMatch.city
            } : order.Location,
            location_id: locationMatch ? locationMatch.id : null, // Add location_id field
            studio: order.Studio,
            sonstige_info: order.SonstigeInfo || "", // Match API field name
            order_id: order.Id, // Store original ID
            proposed_by: localStorage.getItem("userEmail"),
            created_by: localStorage.getItem("userEmail"),
            cost_center1: { value: "", label: "" },
            cost_center2: { value: "", label: "" }
          };

          // console.log("Sending booking data to API:", newOrderData);

          // First, check if the client exists, create if it doesn't
          try {
            // Search for the client by name
            const searchResponse = await companyService.getAllCompanies();
            const clientExists = searchResponse.data.some(
              company => company.name === order.Kundenshootings
            );

            // If client doesn't exist, create it
            if (!clientExists) {
              // console.log(`Creating new client: ${order.Kundenshootings}`);
              const createClientResponse = await companyService.createCompany({
                name: order.Kundenshootings
              });
              // console.log("Client creation response:", createClientResponse.data);
            } else {
              // console.log(`Client already exists: ${order.Kundenshootings}`);
            }
          } catch (error) {
            console.error("Error checking/creating client:", error);
          }

          // Create the booking using the API
          try {
            // console.log(`Creating booking for: ${order.Kundenshootings}, ${order.SetDesc}`);
            const createBookingResponse = await bookingService.createBooking(newOrderData);
            // console.log("✅ Booking created successfully:", createBookingResponse.data);
          } catch (error) {
            console.error("❌ Error creating individual booking:", error);
            if (error.response) {
              console.error("Response status:", error.response.status);
              console.error("Response data:", error.response.data);
            }
            throw error; // Re-throw to be caught by the outer try/catch
          }
        }
      }
      alert("Selected orders have been created!");
      
      // Redirect based on user role
      if (localStorage.getItem("userRole") === "planning") {
        window.location.href = "/cs/allgroups";
      } else {
        window.location.href = "/admin/allgroups";
      }
    } catch (error) {
      console.error("Error creating orders:", error);
      
      // Check for authentication errors first
      if (handleAuthError(error)) {
        return; // Don't show alert if redirecting to login
      }
      
      // Better error display with details if available
      let errorMessage = error.message;
      if (error.response && error.response.data) {
        errorMessage = error.response.data.message || "API Error";
        if (error.response.data.errors) {
          const errorDetails = Object.entries(error.response.data.errors)
            .map(([field, msg]) => `${field}: ${msg}`)
            .join(', ');
          errorMessage += ` (${errorDetails})`;
        }
      }
      
      alert(`Error creating orders: ${errorMessage}`);
    } finally {
      setIsLoading(false);
    }
  };
  // Add the filter handling function
  const handleFilterChange = (key, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [key]: value,
    }));
  };

  // Example of how to apply filters to the potential orders list
  const filteredOrders = useMemo(() => {
    if (!potentialOrders) return [];
    
    return potentialOrders.filter((order) => {
      return (
        (!filters.Studio || order.Studio === filters.Studio) &&
        (!filters.SetDesc || order.SetDesc === filters.SetDesc) &&
        (!filters.Kundenshootings ||
          order.Kundenshootings === filters.Kundenshootings)
      );
      // Add other filter conditions as necessary
    });
  }, [potentialOrders, filters]);

  const uniqueStudioOptions = useMemo(() => {
    if (!potentialOrders) return [];
    
    const allStudios = potentialOrders.map((order) => order.Studio);
    return Array.from(new Set(allStudios)).sort();
  }, [potentialOrders]);

  const uniqueSetDescOptions = useMemo(() => {
    if (!potentialOrders) return [];
    
    const allSetDescs = potentialOrders.map((order) => order.SetDesc);
    return Array.from(new Set(allSetDescs)).sort();
  }, [potentialOrders]);
  
  const uniqueKundednOptions = useMemo(() => {
    if (!potentialOrders) return [];
    
    const allSetDescs = potentialOrders.map((order) => order.Kundenshootings);
    return Array.from(new Set(allSetDescs)).sort();
  }, [potentialOrders]);

  const setDescOptions = uniqueSetDescOptions ? uniqueSetDescOptions.map((setDesc) => ({
    value: setDesc,
    label: setDesc,
  })) : [];
  
  const setStudio = uniqueStudioOptions ? uniqueStudioOptions.map((setDesc) => ({
    value: setDesc,
    label: setDesc,
  })) : [];
  
  const setKunden = uniqueKundednOptions ? uniqueKundednOptions.map((setDesc) => ({
    value: setDesc,
    label: setDesc,
  })) : [];

  // Fetch uploaded Excel files
  const fetchUploadedFiles = async () => {
    try {
      setIsLoading(true);
      const response = await uploadService.getExcelFiles(
        uploadHistoryPage, 
        uploadHistoryLimit
      );
      
      // console.log("API Response for uploaded files:", response.data);
      
      if (response.data && response.data.success) {
        // Use the files array from the response
        setUploadedFiles(response.data.files || []);
        
        // Log pagination info
        if (response.data.pagination) {
          // console.log("Pagination info:", response.data.pagination);
        }
      } else {
        console.error("Failed to fetch uploaded files:", response.data);
      }
    } catch (error) {
      console.error("Error fetching uploaded files:", error);
      
      // Check for authentication errors
      if (handleAuthError(error)) {
        return; // Don't continue if redirecting to login
      }
    } finally {
      setIsLoading(false);
    }
  };

  // Load more upload history
  const loadMoreUploadHistory = () => {
    setUploadHistoryPage(prev => prev + 1);
  };

  // Select previously uploaded file
  const selectUploadedFile = async (fileId) => {
    try {
      setIsLoading(true);
      const previewResponse = await uploadService.previewExcelFile(fileId);
      
      if (previewResponse.data && previewResponse.data.success) {
        // Process the preview data to extract orders
        // This is a placeholder - you would need to adapt this to match your data format
        // console.log("Preview data:", previewResponse.data);
        
        // Download the actual file for processing if needed
        const downloadResponse = await uploadService.downloadExcelFile(fileId);
        
        // Convert the blob to a File object
        const filename = previewResponse.data.file.originalFilename;
        const fileBlob = new Blob([downloadResponse.data], { 
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
        });
        
        // Create a File object
        const fileObject = new File([fileBlob], filename, { 
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        
        setFile(fileObject);
        
        // Process the file
        await processExcelFile(fileObject);
      } else {
        console.error("Failed to preview file:", previewResponse.data);
      }
    } catch (error) {
      console.error("Error selecting uploaded file:", error);
      
      // Check for authentication errors first
      if (handleAuthError(error)) {
        return; // Don't show alert if redirecting to login
      }
      
      alert(`Error selecting file: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  // Process the Excel file to extract orders
  const processExcelFile = async (selectedFile) => {
    // This is a refactored version of the Excel processing part from scanExcel
    try {
      const arrayBuffer = await selectedFile.arrayBuffer();
      
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(arrayBuffer);
      const firstWorksheet = workbook.getWorksheet(2); // Get second worksheet

      if (!firstWorksheet) {
        throw new Error("Worksheet not found");
      }

      // Rest of the existing Excel processing code
      // ... (Copy the processing logic from scanExcel)

      // For now, calling the existing scanExcel function for simplicity
      // In a real implementation, you'd refactor to separate the upload and processing logic
      await scanExcel(selectedFile);
    } catch (error) {
      console.error("Error processing Excel file:", error);
      alert(`Error processing Excel file: ${error.message}`);
    }
  };

  // Toggle upload history display
  const toggleUploadHistory = () => {
    setShowUploadHistory(prev => !prev);
    if (!showUploadHistory && (!uploadedFiles || uploadedFiles.length === 0)) {
      fetchUploadedFiles();
    }
  };

  // Effect to fetch uploaded files when the page changes
  useEffect(() => {
    if (showUploadHistory) {
      fetchUploadedFiles();
    }
  }, [uploadHistoryPage]);

  // Helper function to format file size
  const formatFileSize = (bytes) => {
    if (bytes < 1024) return bytes + ' bytes';
    else if (bytes < 1048576) return (bytes / 1024).toFixed(2) + ' KB';
    else return (bytes / 1048576).toFixed(2) + ' MB';
  };

  // Function to download a file
  const downloadFile = async (fileId, fileName) => {
    try {
      setIsLoading(true);
      
      // console.log(`Downloading file ${fileId}: ${fileName}`);
      const response = await uploadService.downloadExcelFile(fileId);
      
      // Create a blob from the response data
      const blob = new Blob([response.data], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
      });
      
      // Create a URL for the blob
      const url = window.URL.createObjectURL(blob);
      
      // Create a temporary link element
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      
      // Append to body, click, and remove
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Cleanup
      window.URL.revokeObjectURL(url);
      // console.log(`Download complete: ${fileName}`);
    } catch (error) {
      console.error(`Error downloading file ${fileId}:`, error);
      
      // Check for authentication errors first
      if (handleAuthError(error)) {
        return; // Don't show alert if redirecting to login
      }
      
      alert(`Error downloading file: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  // Add this new function to fetch all locations
  const fetchLocations = async () => {
    try {
      // console.log("Fetching locations from API...");
      const response = await locationService.getAllLocations(1, 1000); // Get all locations
      
      // Process the response based on possible data structures
      let locationsList = [];
      if (response.data?.locations) {
        locationsList = response.data.locations;
      } else if (Array.isArray(response.data)) {
        locationsList = response.data;
      }
      
      // console.log(`Found ${locationsList.length} locations:`, locationsList);
      setLocations(locationsList);
    } catch (error) {
      console.error("Error fetching locations:", error);
      
      // Check for authentication errors
      handleAuthError(error);
    }
  };

  // Update useEffect to fetch locations when component mounts
  useEffect(() => {
    fetchLocations();
  }, []);

  // Helper function to find location ID by name, short code, or city
  const findLocationId = (locationText) => {
    if (!locationText || !locations || locations.length === 0) return null;
    
    // Normalize the search text to lowercase for case-insensitive comparison
    const normalizedText = locationText.toLowerCase().trim();
    // console.log(`Looking for location match for: "${normalizedText}"`);
    
    // First look for exact matches on name, short, or city
    let match = locations.find(loc => 
      (loc.name && loc.name.toLowerCase() === normalizedText) ||
      (loc.short && loc.short.toLowerCase() === normalizedText) ||
      (loc.city && loc.city.toLowerCase() === normalizedText)
    );
    
    // If no exact match, try partial matches
    if (!match) {
      match = locations.find(loc => 
        (loc.name && loc.name.toLowerCase().includes(normalizedText)) ||
        (loc.short && loc.short.toLowerCase().includes(normalizedText)) ||
        (loc.city && loc.city.toLowerCase().includes(normalizedText))
      );
    }
    
    if (match) {
      // console.log(`✅ Found location match:`, match);
      return {
        id: match.id,
        name: match.name,
        short: match.short,
        city: match.city
      };
    }
    
    // console.log(`❌ No location match found for "${normalizedText}"`);
    return null;
  };

  return (
    <div className="content-wrapper page">
      <div className="content-wrapper">
        <div>
          {!potentialOrders || potentialOrders.length === 0 ? (
            // If no orders have been processed, show the "Choose File" button
            <div>
              <label htmlFor="fileInput" className="big-button">
                Choose File
              </label>
              <input
                type="file"
                id="fileInput"
                accept=".xls,.xlsx"
                onChange={handleChange}
                style={{ display: "none", width: '320px' }}
              />
              
              <button 
                className="big-button" 
                style={{ marginTop: "20px", width: '320px'}}
                onClick={toggleUploadHistory}
              >
                {showUploadHistory ? "Hide Upload History" : "Show Upload History"}
              </button>
              
              {showUploadHistory && (
                <div className="upload-history-container" style={{ 
                  marginTop: "20px"
                }}>
                  <h2 style={{ marginBottom: "15px" }}>Previously Uploaded Files</h2>
                  
                  {!uploadedFiles || uploadedFiles.length === 0 ? (
                    <p>No previously uploaded files found.</p>
                  ) : (
                    <>
                      <ul className="upload-history-list" style={{ 
                        listStyle: "none", 
                        padding: 0, 
                        margin: 0 
                      }}>
                        {uploadedFiles.map((file) => (
                          <li key={file.id} className="upload-history-item" style={{ 
                            display: "flex", 
                            flexDirection: window.innerWidth < 768 ? "column" : "row",
                            justifyContent: "space-between", 
                            alignItems: window.innerWidth < 768 ? "flex-start" : "center", 
                            padding: "15px 0", 
                            marginBottom: "10px",
                            backgroundColor: "#fff",
                          }}>
                            <div className="upload-details" style={{ 
                              flex: 1,
                              marginBottom: window.innerWidth < 768 ? "15px" : "0"
                            }}>
                              <div className="upload-filename" style={{ 
                                fontWeight: "bold", 
                                fontSize: "16px",
                                color: "#333"
                              }}>
                                {file.originalFilename}
                              </div>
                              <div className="upload-date" style={{ 
                                color: "#666", 
                                fontSize: "14px", 
                                marginTop: "5px" 
                              }}>
                                <span style={{ fontWeight: "500" }}>Uploaded:</span> {new Date(file.uploadDate).toLocaleString()}
                              </div>
                              <div className="upload-size" style={{ 
                                fontSize: "14px", 
                                marginTop: "5px",
                                color: "#666"
                              }}>
                                <span style={{ fontWeight: "500" }}>Size:</span> {formatFileSize(file.size)}
                              </div>
                              {file.description && (
                                <div className="upload-description" style={{ 
                                  fontSize: "14px", 
                                  marginTop: "5px",
                                  color: "#666"
                                }}>
                                  <span style={{ fontWeight: "500" }}>Description:</span> {file.description}
                                </div>
                              )}
                            </div>
                            <div className="upload-actions" style={{
                              display: "flex",
                              flexDirection: window.innerWidth < 768 ? "row" : "row",
                              width: window.innerWidth < 768 ? "100%" : "auto"
                            }}>
                              <button
                                className="button"
                                style={{ 
                                  cursor: "pointer",
                                  flex: window.innerWidth < 768 ? "1" : "auto"
                                }}
                                onClick={() => downloadFile(file.id, file.originalFilename)}
                              >
                                Download
                              </button>
                              <button
                                className="button"
                                style={{ 
                                  cursor: "pointer",
                                  flex: window.innerWidth < 768 ? "1" : "auto"
                                }}
                                onClick={() => selectUploadedFile(file.id)}
                              >
                                Use This File
                              </button>
                            </div>
                          </li>
                        ))}
                      </ul>
                      
                      {uploadedFiles.length > 0 && (
                        <div style={{ 
                          display: "flex", 
                          justifyContent: "center", 
                          marginTop: "20px" 
                        }}>
                          <button
                            className="button"                            onClick={loadMoreUploadHistory}
                          >
                            Load More
                          </button>
                        </div>
                      )}
                    </>
                  )}
                </div>
              )}
            </div>
          ) : isloading ? (
            // If isLoading is true, show the spinner
            <div className="spinner"></div>
          ) : (
            // If there are potential orders and is not loading, show the orders list
            <>
              <h1>Potential Orders</h1>
              <div style={{ marginTop: "50px", marginBottom: "50px" }}>
                <div style={{ display: "flex" }}>
                  <button
                    className="button"
                    style={{ width: "200px", margin: "5px" }}
                    onClick={toggleSelectAll}
                  >
                    {selectAll ? "Unselect All" : "Select All"}
                  </button>
                  <button
                    className="button"
                    style={{ width: "200px", margin: "5px" }}
                    onClick={createSelectedOrders}
                  >
                    Create selected orders
                  </button>
                </div>
              </div>
              <div
                style={{
                  marginTop: "0px",
                  marginBottom: "60px",
                  display: "flex",
                }}
              >
                <Select
                  value={
                    filters.SetDesc
                      ? setDescOptions.find(
                          (option) => option.value === filters.SetDesc
                        )
                      : null
                  }
                  onChange={(selectedOption) =>
                    handleFilterChange(
                      "SetDesc",
                      selectedOption ? selectedOption.value : ""
                    )
                  }
                  options={setDescOptions}
                  isClearable
                  placeholder="Filter by Set"
                  components={{ DropdownIndicator }}
                  styles={customStyles}
                />
                <Select
                  value={
                    filters.Studio
                      ? setDescOptions.find(
                          (option) => option.value === filters.Studio
                        )
                      : null
                  }
                  onChange={(selectedOption) =>
                    handleFilterChange(
                      "Studio",
                      selectedOption ? selectedOption.value : ""
                    )
                  }
                  options={setStudio}
                  isClearable
                  placeholder="Filter by Studio"
                  components={{ DropdownIndicator }}
                  styles={customStyles}
                />
                <Select
                  value={
                    filters.Kundenshootings
                      ? setDescOptions.find(
                          (option) => option.value === filters.Kundenshootings
                        )
                      : null
                  }
                  onChange={(selectedOption) =>
                    handleFilterChange(
                      "Kundenshootings",
                      selectedOption ? selectedOption.value : ""
                    )
                  }
                  options={setKunden}
                  isClearable
                  placeholder="Filter by Client"
                  components={{ DropdownIndicator }}
                  styles={customStyles}
                />
              </div>
              <div className="list-tasks-header">
                <div style={{ flexBasis: "30px" }}>
                  <img src={sort} height="30px" />
                </div>
                <div
                  style={{ flexBasis: "100px" }}
                  onClick={() => requestSort("Studio")}
                >
                  Studio{" "}
                </div>
                <div
                  style={{ flexBasis: "80px" }}
                  onClick={() => requestSort("SetDesc")}
                >
                  Set
                </div>
                <div
                  style={{ flexBasis: "120px" }}
                  onClick={() => requestSort("Datum")}
                >
                  Datum
                </div>
                <div
                  style={{ flexBasis: "200px" }}
                  onClick={() => requestSort("Kundenshootings")}
                >
                  Kunden
                </div>
                <div
                  style={{ flexBasis: "50px" }}
                  onClick={() => requestSort("KPIPlan")}
                >
                  {" "}
                  KPI{" "}
                </div>
                <div
                  style={{ flexBasis: "100px" }}
                  onClick={() => requestSort("position")}
                >
                  Position
                </div>
                <div
                  style={{ flexBasis: "100px" }}
                  onClick={() => requestSort("SonstigeInfo")}
                >
                  S.Info
                </div>
                <div
                  style={{ flexBasis: "150px" }}
                  onClick={() => requestSort("Location")}
                >
                  Location
                </div>
                <div
                  style={{ flexBasis: "300px" }}
                  onClick={() => requestSort("Id")}
                >
                  Id
                </div>
              </div>
              <ul>
                {filteredOrders.map((order, index) => {
                  const hasError =
                    !order.Id || !order.Kundenshootings || !order.Datum  || !order.SetDesc;
                  const itsOptional = order.SonstigeInfo === "Optional";
                  return (
                    <li
                      key={index}
                      className={`list-tasks-item ${
                        hasError ? "error-row" : ""
                      } ${itsOptional ? "optional" : ""}`}
                    >
                      <div
                        style={{ flexBasis: "30px" }}
                        className="custom-checkbox"
                      >
                        <input
                          type="checkbox"
                          id={`checkbox-${index}`}
                          checked={!!selectedOrders[index]}
                          onChange={() => handleCheckboxChange(index)}
                        />
                        <label htmlFor={`checkbox-${index}`}></label>
                      </div>

                      <div style={{ flexBasis: "100px" }}>{order.Studio}</div>
                      <div style={{ flexBasis: "80px" }}>{order.SetDesc}</div>
                      <div style={{ flexBasis: "120px" }}>
                        {reformatDate(order.Datum)} <br />
                        {normalizeTime(order.Start)}-{normalizeTime(order.Ende)}
                      </div>
                      <div style={{ flexBasis: "200px" }}>
                        {" "}
                        {order.Kundenshootings}
                      </div>
                      <div style={{ flexBasis: "50px" }}>{order.KPIPlan}</div>
                      <div style={{ flexBasis: "100px" }}>{order.position}</div>
                      <div style={{ flexBasis: "100px" }}>
                        {order.SonstigeInfo}
                      </div>
                      <div style={{ flexBasis: "150px" }}>{order.Location}</div>
                      <div style={{ flexBasis: "300px" }}>{order.Id}</div>
                    </li>
                  );
                })}
              </ul>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ExcelUploadButton;